import { Alert } from "@/shared/feedback/alert";
import { useTranslations } from "use-intl";

/**
 * Объясняет, почему форма закрыта на редактирование: часть её полей приехала скрытой,
 * и сохранение стёрло бы их. Показывается вместе с `disabled` на форме.
 */
export function HiddenFieldsAlert() {
  const t = useTranslations("Common");

  return (
    <Alert type={"warning"} showIcon message={t("HIDDEN_FIELDS_BLOCK_SAVE")} />
  );
}
